class @App.Components.Searchbar
  $('body').on 'click', '[data-searchbar-btn]', (e) ->
    $searchBar = $($(e.currentTarget).data('searchbar-btn'))
    $searchField = $searchBar.find('input[type="search"]')
    return if not $searchField.length
    unless $searchBar.hasClass 'tdd-searchbar--open'
      e.preventDefault()
      $searchBar.addClass 'tdd-searchbar--open'
      $searchField.focus()

  $('body').on 'click', '[data-searchbar-close]', (e) =>
    $searchBar = $($(e.currentTarget).data('searchbar-close')).removeClass 'tdd-searchbar--open'
    return if $searchBar.length < 1
    e.preventDefault()
    $searchBar.find('input[type="search"]').val('').blur()
    $searchBar.removeClass 'tdd-searchbar--open'

$ ->
  new App.Components.Searchbar
